<template>
    <div class="course-progress">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <div class="course-progress--root">
            <cmp-cpo-preview class="course-progress--preview"
                    :section="firstSection">
            </cmp-cpo-preview>

            <component @request-action="requestOverlay"
                    class="course-progress--btn"
                    :is="content.overlay_button.type"
                    :plugin="content.overlay_button">
            </component>
        </div>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import { mapActions } from 'vuex';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
        ],
        computed: {
            firstSection() {
                return get(this, 'content.sections[0]', {});
            },
        },
        methods: {
            ...mapActions(['openOverlay', 'closeOverlay']),
            requestOverlay() {
                this.openOverlay({
                    facet: 'course-progress',
                    component: 'cmp-cpo',
                    props: this.content,
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?800e16ec